import Eos from 'eosjs';
import axios from 'axios';
import auth from './auth';

var AmazonCognitoIdentity = require('amazon-cognito-identity-js');
var CognitoUserPool = AmazonCognitoIdentity.CognitoUserPool;

// initial state
const state = {
    user: null,
    token: {},
    message: '',
    isDark: false,
    isOpenSidebar: false,
    logMessage: ''
}

const getters = {
    authenticatedUser: state => state.user,
    getLogMessage: state => state.logMessage,
}

const mutations = {
    changeMessage(state, message) {
        state.message = message
    },
    toggleDarkTheme(state) {
        state.isDark = !state.isDark
    },
    openSidebar(state) {
        state.isOpenSidebar = true
    },
    closeSidebar(state) {
        state.isOpenSidebar = true
    },
    commitLogMessage(state, message) {
        state.logMessage = message
        console.log(message)
    }
}

const actions = {
    resetMessage(context) {
        context.commit('util/changeMessage', "boom", { root: true })
    },
    toggleDark(context) {
        context.commit('util/toggleDarkTheme', null, { root: true })
    },
    toggleSidebarOpen(context) {
        context.commit('util/openSidebar', null, { root: true })
    },
    toggleSidebarClosed(context) {
        context.commit('util/closeSidebar', null, { root: true })
    },
    processLog(context, params) {
        context.commit('util/commitLogMessgae', params.message, { root: true })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}